import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from '../../services/admin.service';

@Component({
  selector: 'app-team-dialog',
  templateUrl: './team-dialog.component.html',
  styleUrls: ['./team-dialog.component.scss']
})
export class TeamDialogComponent implements OnInit {
  teamForm: FormGroup;
  isEditMode = false;
  leagues: any[] = [];
  previewUrl: string | ArrayBuffer | null = null;
  selectedFile: File | null = null;

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    public dialogRef: MatDialogRef<TeamDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isEditMode = !!data.team;
    this.teamForm = this.fb.group({
      name: [data.team ? data.team.name : '', Validators.required],
      leagueId: [data.team ? data.team.leagueId : '', Validators.required],
      iconUrl: ['']
    });

    if (this.isEditMode && data.team.iconUrl) {
      this.previewUrl = data.team.iconUrl;
    }
  }

  ngOnInit(): void {
    this.loadLeagues();
  }

  loadLeagues(): void {
    this.adminService.getAllLeagues().subscribe((data) => {
      this.leagues = data.content;
    });
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;

      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
      };
      reader.readAsDataURL(file);

      this.uploadTeamLogo();
    }
  }

  private uploadTeamLogo(): void {
    const formData = new FormData();
    formData.append('file', this.selectedFile!);

    this.adminService.uploadTeamLogo(this.data.team.id, this.selectedFile!).subscribe({
      next: (response) => {
        this.teamForm.get('iconUrl')?.setValue(response.url);
      },
      error: (err) => {
        console.error('Failed to upload team logo', err);
      }
    });
  }

  onSave(): void {
    if (this.teamForm.valid) {
      this.saveTeamData();
    }
  }

  private saveTeamData(): void {
    const teamData = {
      ...this.teamForm.value,
      iconUrl: this.teamForm.get('iconUrl')?.value
    };

    if (this.isEditMode) {
      this.adminService.updateTeamFromOneLeague(this.data.team.id, teamData).subscribe(() => {
        this.dialogRef.close(true);
      });
    } else {
      this.adminService.createTeamFromOneLeague(teamData).subscribe(() => {
        this.dialogRef.close(true);
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
